<template>
  <metainfo>
    <link rel="stylesheet" :href="context.basis.css" media="all" />
    <!-- <template v-html="context.basis.favicon"></template> -->
    <component :is="'script'">{{ headscript }}</component>
  </metainfo>

  <visitor-identification />

  <header class="header">
    <microsite-header :context="context" />
  </header>

  <main>
    <aufmacher :context="context" />
    <placeholder name="Main" :rendering="route" :context="context" />
  </main>

  <footer class="footer" role="contentinfo">
    <microsite-footer :context="context" />
  </footer>

  <teleport to="body">
    <component src="/ms-sys/00-ms-base/dist/js/ms-main-min.js" :is="'script'" />
  </teleport>
</template>

<script>
import { defineComponent } from 'vue';
import VisitorIdentification from '../VisitorIdentification';
import Aufmacher from '../components/Microsites/Aufmacher';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';
import MicrositeHeader from './Microsite/MicrositeHeader';
import MicrositeFooter from './Microsite/MicrositeFooter';
import { stateMicrosites } from '../globalMicrosites';

export default defineComponent({
  name: 'Layout',
  data() {
    const headscript =
      "!function (e, t, n) { function r(e) { var t = w.className, n = Modernizr._config.classPrefix || ''; if (x && (t = t.baseVal), Modernizr._config.enableJSClass) { var r = new RegExp('(^|\\s)' + n + 'no-js(\\s|$)'); t = t.replace(r, '$1' + n + 'js$2') } Modernizr._config.enableClasses && (t += ' ' + n + e.join(' ' + n), x ? w.className.baseVal = t : w.className = t) } function o(e, t) { return typeof e === t } function i() { var e, t, n, r, i, s, a; for (var l in C) if (C.hasOwnProperty(l)) { if (e = [], t = C[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++)e.push(t.options.aliases[n].toLowerCase()); for (r = o(t.fn, 'function') ? t.fn() : t.fn, i = 0; i < e.length; i++)s = e[i], a = s.split('.'), 1 === a.length ? Modernizr[a[0]] = r : (!Modernizr[a[0]] || Modernizr[a[0]] instanceof Boolean || (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])), Modernizr[a[0]][a[1]] = r), g.push((r ? '' : 'no-') + a.join('-')) } } function s() { return 'function' != typeof t.createElement ? t.createElement(arguments[0]) : x ? t.createElementNS.call(t, 'http://www.w3.org/2000/svg', arguments[0]) : t.createElement.apply(t, arguments) } function a() { var e = t.body; return e || (e = s(x ? 'svg' : 'body'), e.fake = !0), e } function l(e, n, r, o) { var i, l, u, f, c = 'modernizr', d = s('div'), p = a(); if (parseInt(r, 10)) for (; r--;)u = s('div'), u.id = o ? o[r] : c + (r + 1), d.appendChild(u); return i = s('style'), i.type = 'text/css', i.id = 's' + c, (p.fake ? p : d).appendChild(i), p.appendChild(d), i.styleSheet ? i.styleSheet.cssText = e : i.appendChild(t.createTextNode(e)), d.id = c, p.fake && (p.style.background = '', p.style.overflow = 'hidden', f = w.style.overflow, w.style.overflow = 'hidden', w.appendChild(p)), l = n(d, e), p.fake ? (p.parentNode.removeChild(p), w.style.overflow = f, w.offsetHeight) : d.parentNode.removeChild(d), !!l } function u(e) { return e.replace(/([a-z])-([a-z])/g, function (e, t, n) { return t + n.toUpperCase() }).replace(/^-/, '') } function f(e, t) { return !!~('' + e).indexOf(t) } function c(e, t) { return function () { return e.apply(t, arguments) } } function d(e, t, n) { var r; for (var i in e) if (e[i] in t) return n === !1 ? e[i] : (r = t[e[i]], o(r, 'function') ? c(r, n || t) : r); return !1 } function p(e) { return e.replace(/([A-Z])/g, function (e, t) { return '-' + t.toLowerCase() }).replace(/^ms-/, '-ms-') } function m(t, n, r) { var o; if ('getComputedStyle' in e) { o = getComputedStyle.call(e, t, n); var i = e.console; if (null !== o) r && (o = o.getPropertyValue(r)); else if (i) { var s = i.error ? 'error' : 'log'; i[s].call(i, 'getComputedStyle returning null, its possible modernizr test results are inaccurate') } } else o = !n && t.currentStyle && t.currentStyle[r]; return o } function v(t, r) { var o = t.length; if ('CSS' in e && 'supports' in e.CSS) { for (; o--;)if (e.CSS.supports(p(t[o]), r)) return !0; return !1 } if ('CSSSupportsRule' in e) { for (var i = []; o--;)i.push('(' + p(t[o]) + ':' + r + ')'); return i = i.join(' or '), l('@supports (' + i + ') { #modernizr { position: absolute; } }', function (e) { return 'absolute' == m(e, null, 'position') }) } return n } function h(e, t, r, i) { function a() { c && (delete k.style, delete k.modElem) } if (i = o(i, 'undefined') ? !1 : i, !o(r, 'undefined')) { var l = v(e, r); if (!o(l, 'undefined')) return l } for (var c, d, p, m, h, y = ['modernizr', 'tspan', 'samp']; !k.style && y.length;)c = !0, k.modElem = s(y.shift()), k.style = k.modElem.style; for (p = e.length, d = 0; p > d; d++)if (m = e[d], h = k.style[m], f(m, '-') && (m = u(m)), k.style[m] !== n) { if (i || o(r, 'undefined')) return a(), 'pfx' == t ? m : !0; try { k.style[m] = r } catch (g) { } if (k.style[m] != h) return a(), 'pfx' == t ? m : !0 } return a(), !1 } function y(e, t, n, r, i) { var s = e.charAt(0).toUpperCase() + e.slice(1), a = (e + ' ' + E.join(s + ' ') + s).split(' '); return o(t, 'string') || o(t, 'undefined') ? h(a, t, r, i) : (a = (e + ' ' + P.join(s + ' ') + s).split(' '), d(a, t, n)) } var g = [], C = [], S = { _version: '3.4.0', _config: { classPrefix: '', enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function (e, t) { var n = this; setTimeout(function () { t(n[e]) }, 0) }, addTest: function (e, t, n) { C.push({ name: e, fn: t, options: n }) }, addAsyncTest: function (e) { C.push({ name: null, fn: e }) } }, Modernizr = function () { }; Modernizr.prototype = S, Modernizr = new Modernizr, Modernizr.addTest('svg', !!t.createElementNS && !!t.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect); var w = t.documentElement, x = 'svg' === w.nodeName.toLowerCase(), _ = S._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['', '']; S._prefixes = _, Modernizr.addTest('csspositionsticky', function () { var e = 'position:', t = 'sticky', n = s('a'), r = n.style; return r.cssText = e + _.join(t + ';' + e).slice(0, -e.length), -1 !== r.position.indexOf(t) }); var b = function () { var t = e.matchMedia || e.msMatchMedia; return t ? function (e) { var n = t(e); return n && n.matches || !1 } : function (t) { var n = !1; return l('@media ' + t + ' { #modernizr { position: absolute; } }', function (t) { n = 'absolute' == (e.getComputedStyle ? e.getComputedStyle(t, null) : t.currentStyle).position }), n } }(); S.mq = b; var T = S.testStyles = l; Modernizr.addTest('touchevents', function () { var n; if ('ontouchstart' in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0; else { var r = ['@media (', _.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join(''); T(r, function (e) { n = 9 === e.offsetTop }) } return n }); var z = 'Moz O ms Webkit', E = S._config.usePrefixes ? z.split(' ') : []; S._cssomPrefixes = E; var N = function (t) { var r, o = _.length, i = e.CSSRule; if ('undefined' == typeof i) return n; if (!t) return !1; if (t = t.replace(/^@/, ''), r = t.replace(/-/g, '_').toUpperCase() + '_RULE', r in i) return '@' + t; for (var s = 0; o > s; s++) { var a = _[s], l = a.toUpperCase() + '_' + r; if (l in i) return '@-' + a.toLowerCase() + '-' + t } return !1 }; S.atRule = N; var P = S._config.usePrefixes ? z.toLowerCase().split(' ') : []; S._domPrefixes = P; var j = { elem: s('modernizr') }; Modernizr._q.push(function () { delete j.elem }); var k = { style: j.elem.style }; Modernizr._q.unshift(function () { delete k.style }), S.testAllProps = y; var L = S.prefixed = function (e, t, n) { return 0 === e.indexOf('@') ? N(e) : (-1 != e.indexOf('-') && (e = u(e)), t ? y(e, t, n) : y(e, 'pfx')) }; Modernizr.addTest('matchmedia', !!L('matchMedia', e)), i(), r(g), delete S.addTest, delete S.addAsyncTest; for (var O = 0; O < Modernizr._q.length; O++)Modernizr._q[O](); e.Modernizr = Modernizr }(window, document);";
    return { 
      headscript,
    };
  },
  props: {
    route: {
      type: Object,
      default: () => ({}),
    },
    context: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Placeholder,
    Aufmacher,
    MicrositeHeader,
    MicrositeFooter,
    VisitorIdentification
  },
  mounted() {
      this.insertContent(this.context.basis.favicon, stateMicrosites.hasInsertedFavicon);
      this.insertContent(this.context.basis.googletagmanager, stateMicrosites.hasInsertedGoogleTagmanager);
    },
  methods: {
    // insertFavicon(content, ) {
    //   if (stateMicrosites.hasInsertedFavicon.value || !content) return;
      
    //   const lines = content.split("\n").map((line) => line.trim()).filter((line) => line);
      
    //   lines.forEach((line) => {
    //     // Parse das Element, basierend auf dem Typ (<meta> oder <link>)
    //     if (line.startsWith("<meta") || line.startsWith("<link")) {
    //       this.insertTag(line);          
    //     } else if (line.startsWith("<!--") && line.endsWith("-->")) {
    //       this.insertComment(line);
    //     }
    //   });
      
    //   stateMicrosites.hasInsertedFavicon.value = true;
    // },

    insertContent(content, inserted) {
      if (inserted.value || !content) return;
      
      // Tricky das passt :-D
      let newString = '<p>XXX</p>' + content.replace(/<noscript>.*?<\/noscript>/is, '');

      console.log(newString);

      const parser = new DOMParser();
      const doc = parser.parseFromString(newString, "text/html");

      // Iteriere über alle Knoten des geparsten Dokuments
      Array.from(doc.body.childNodes).forEach((node, index) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'SCRIPT') {
            // <script> speziell behandeln, um sicherzustellen, dass es ausgeführt wird
            const script = document.createElement('script');
            if (node.src) {
              script.src = node.src;
              script.async = node.async;
            } else {
              script.textContent = node.textContent;
            }
            document.head.appendChild(script);
          } else {
            if (node.textContent != 'XXX')
              document.head.appendChild(node);
          }
        } else if (node.nodeType === Node.COMMENT_NODE) {
          const commentNode = document.createComment(node.nodeValue.trim());
          document.head.appendChild(commentNode);
        }
      });
      
      inserted.value = true;
    },
    // insertTag(metaString) {
    //   const tempDiv = document.createElement("div");
    //   tempDiv.innerHTML = metaString.trim();
    //   const metaTag = tempDiv.firstChild;
    //   if (metaTag) {
    //     document.head.appendChild(metaTag);
    //   }
    // },
    // insertComment(commentString) {
    //   const commentContent = commentString.slice(4, -3).trim(); // Entfernt `<!--` und `-->`
    //   const commentNode = document.createComment(commentContent);
    //   document.head.appendChild(commentNode);
    // },
    // insertLinkTag(linkString) {
    //   const tempDiv = document.createElement("div");
    //   tempDiv.innerHTML = linkString.trim();
    //   const linkTag = tempDiv.firstChild;
    //   if (linkTag) {
    //     document.head.appendChild(linkTag);
    //   }
    // },
  },
});
</script>
